import classNames from "classnames";
import { Tooltip } from "antd";
import { Link } from "react-router-dom";
import "./OneLineText.scss";
import React from "react";

export interface OneLineTextProps {
  /**Used to change style Component */
  className?: string;
  /**URL of avatar to display */
  avatar?: string;
  /**Shape option of avatar*/
  avatarType?: "circle" | "square";
  /** Icon name to display */
  icon?: string;
  /** Value to display */
  value?: string;
  /**Option to add link into cell */
  link?: string;
  /**Use tooltip for data in cell */
  useTooltip?: boolean;
}

function OneLineText(props: OneLineTextProps) {
  const {
    className,
    avatar = null,
    value,
    icon = null,
    link,
    avatarType = "circle",
    useTooltip = true,
  } = props;
  return (
    <>
      {avatar && (
        <div className={classNames("text-in-table-cell", className)}>
          {avatar && (
            <img
              src={avatar}
              className={classNames(
                `avatar-one-line-text`,
                `avatar-type-${avatarType}`
              )}
              alt="avatar"
            />
          )}
          {link ? (
            <a
              href={link}
              rel="noopener noreferrer"
              className="link-text w100pc-28px"
            >
              {useTooltip ? (
                <Tooltip title={value} placement="topLeft">
                  <div className="text-ellipsis">{value}</div>
                </Tooltip>
              ) : (
                <div className="text-ellipsis">{value}</div>
              )}
            </a>
          ) : (
            <div className="w100pc-32px">
              {useTooltip ? (
                <Tooltip
                  title={value}
                  placement={value?.length <= 1 ? "top" : "topLeft"}
                >
                  <div className="text-ellipsis">{value}</div>
                </Tooltip>
              ) : (
                <div className="text-ellipsis">{value}</div>
              )}
            </div>
          )}
        </div>
      )}
      {!avatar && (
        <div className={classNames(className, "text-in-table-cell")}>
          {icon && <i className={classNames(icon, `icon-one-line-text`)}></i>}
          {link ? (
            <Link to={link} className="link-text w100pc">
              {useTooltip ? (
                <Tooltip title={value} placement="topLeft">
                  <div className="text-ellipsis">{value}</div>
                </Tooltip>
              ) : (
                <div className="text-ellipsis">{value}</div>
              )}
            </Link>
          ) : (
            <div className="w100pc">
              {useTooltip ? (
                <Tooltip
                  title={value}
                  placement={value?.length <= 1 ? "top" : "topLeft"}
                >
                  <div className="text-ellipsis">{value}</div>
                </Tooltip>
              ) : (
                <div className="text-ellipsis">{value}</div>
              )}
            </div>
          )}
        </div>
      )}
    </>
  );
}
export default OneLineText;
